module.exports = __webpack_public_path__ + "media/images/icons/zoom-in-80732825d60dc3a71db87a1ddd4c142f.svg";